<template>
    <p>Are you sure you want to delete this Inventory Type?</p>
    <br />
    <p>[ {{ item.name }} ]</p>
</template>

<script setup lang="ts">
import { useInjectSubmitForm } from '@shared/composables/action-dialog/useInjectSubmitForm';
import { type IInventoryType } from '@app/land-hold/inventory-type/models/InventoryType';
import { useInventoryTypeRepository } from '@app/land-hold/inventory-type/repositories/useInventoryTypeRepository';

const props = defineProps({
    item: {
        type: Object as PropType<IInventoryType>,
        required: true,
    },
});

const destroy = useInventoryTypeRepository().command.destroy(props.item.id);
useInjectSubmitForm(destroy.execute);
</script>
